/* eslint-disable */
import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";

// //import translation function for language translation
import { useTranslation } from "react-i18next";

// /*import url and gateway methods */
import { getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import constext
import { GlobalProvider } from "context/GlobalContext";

import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";

const localizer = momentLocalizer(moment);

const MaterialCalendarBody = ({ selectedKit }) => {
  const { t, i18n } = useTranslation();

  /* ========== get user id from url params ========= */
  const params = useParams();
  const token = localStorage.getItem("token"); // for token

  //import conext
  const {
    reloadScheduleMaterial,
    setReloadScheduleMaterial,
    setEditScheduleMaterialData,
    agendaWaitning,
    setAgendaWaitning,
  } = useContext(GlobalProvider);

  // default user data ------------------------------------
  const [calendarData, setCalendarData] = useState([]);
  const [responseReceived, setResponseReceived] = useState(false);

  // get json data about date ------------------------------
  const currentYear = new Date().getFullYear();

  const parseAdjust = (eventDate) => {
    const date = new Date(eventDate);
    date.setFullYear(currentYear);
    return date;
  };

  const handleNavigate = (date) => {
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    getAllAgenda(month, year);
  };

  // function for get all calendar data
  const getAllAgenda = async (month, year) => {
    setAgendaWaitning(true);
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_SCHEDULE_MATERIALKIT +
        `?token=${token}&month=${month}&year=${year}&materialkit=${params.id}`;

      console.log("Url of calender list========>", requestUrl);

      const response = await getData(requestUrl);
      console.log(`response in calender list ==============>`, response.data);

      if (response.status) {
        setAgendaWaitning(false);
        setCalendarData(response.data);
        setResponseReceived(true);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  // set response to match kendo scheduler event schema --------------------------------
  const kendoCalendarData = calendarData.map((dataItem, index) => ({
    id: index + 1,
    start: parseAdjust(dataItem.start, dataItem.starttime),
    end: parseAdjust(dataItem.end, dataItem.endtime),
    isAllDay: false,
    title: dataItem.title,
    description: dataItem.description,
    date: dataItem.date,
    availability: dataItem.surplus,
    starttime: dataItem.starttime,
    endtime: dataItem.endtime,
    color: dataItem.color,
  }));

  console.log("kendo calendar data -->", kendoCalendarData);

  /*---------- Handel Edit Calendar Schedule data ------------*/
  const scheduleItemHandler = (event) => {
    //assign schedule date in context
    setEditScheduleMaterialData(event.resource);

    const offcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("editMaterialSchedulePopup")
    );
    offcanvas.show();
  };

  const eventStyleGetter = (event) => {
    return {
      style: {
        backgroundColor: event.resource && event.resource.color ? event.resource.color : "#3174ad",
      },
    };
  };

  useEffect(() => {
    const currentDate = new Date();
    const month = currentDate.getMonth() + 1; // Get the current month name
    const year = currentDate.getFullYear(); // Get the current full year

    getAllAgenda(month, year);
  }, []);

  return (
    <Calendar
      localizer={localizer}
      events={(kendoCalendarData || []).map((ev) => ({
        title: ev.title || "",
        start: new Date(ev.start),
        end: new Date(ev.end),
        resource: ev,
      }))}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 600 }}
      views={["month", "week", "day", "agenda"]}
      defaultView="month"
      onSelectEvent={scheduleItemHandler}
      onNavigate={handleNavigate}
      eventPropGetter={eventStyleGetter}
    />
  );
};

export default MaterialCalendarBody;
